<template>
    <div class="cb-step indexing">
        <div class="cb-step-header">
            <div class="cb-step-icon"></div>
            <div class="cb-step-title">{{ $t('frm_ai_indexing_title') }}</div>
            <div class="cb-step-sub-title">
                {{ $t('frm_ai_indexing_message_prefix') }}
                <strong>{{ versionName }}</strong>
                {{ $t('frm_ai_indexing_message_suffix') }}
            </div>
        </div>
        <div class="cb-step-body">
            <div v-if="getItem('indexingStatus') !== 'error'" class="cb-indexing-loading">
                <div class="cb-indexing-spinner"></div>
                <div class="cb-indexing-label">{{ $t('frm_ai_indexing_label') }}</div>
                <div class="cb-indexing-hint">{{ $t('frm_ai_indexing_close_hint') }}</div>
                <button class="cb-indexing-close" type="button" @click="handleCloseForNow">
                    {{ $t('frm_ai_indexing_close_button') }}
                </button>
            </div>
            <div v-else class="cb-indexing-error">
                <p>{{ indexingErrorText }}</p>
                <div class="cb-btn-next" @click="handleRetry">{{ $t('frm_ai_indexing_retry') }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { createNamespacedHelpers } from 'vuex';
    const { mapActions: aiChatMapActions, mapGetters: aiChatMapGetters } = createNamespacedHelpers('aichat')
    export default {
        name: "ChatIndexingState",
        computed: {
            ...aiChatMapGetters([
                'getItem'
            ]),
            versionName() {
                return this.getItem('versionName');
            },
            indexingErrorText() {
                const code = this.getItem('indexingError');
                if (code === 'openai_index_timeout') {
                    return this.$t('frm_ai_indexing_timeout');
                }
                if (code === 'openai_index_failed') {
                    return this.$t('frm_ai_indexing_error');
                }
                return this.$t('frm_ai_indexing_error');
            }
        },
        methods: {
            ...aiChatMapActions([
                'retryIndexing',
                'closeChat'
            ]),
            handleRetry() {
                this.retryIndexing();
            },
            handleCloseForNow() {
                this.closeChat();
            }
        }
    }
</script>
